import { CheckCircle2, ClipboardList } from "lucide-react";
import EmailResultsCard from "@/components/checkup/EmailResultsCard";
import ReviewCta from "@/components/checkup/ReviewCta";

export default function RecapResults({ result, pathway, assessmentId }) {
  const { results } = pathway;
  const Icon = pathway.icon;
  const recap = (result.recap || []).filter((r) => r.value && r.value !== "—");

  return (
    <>
      <div className={`pw-${pathway.key} pw-card text-cream rounded-3xl p-7 sm:p-10 text-center hero-grain relative overflow-hidden border border-gold/30 shadow-[0_30px_70px_-24px_rgba(11,25,44,0.55)]`} data-testid="recap-results-hero">
        <div className="absolute inset-0 pw-card-glow" />
        <div className="relative">
          <span className="mx-auto w-16 h-16 rounded-full border-2 border-[#D6BB7C] bg-black/20 flex items-center justify-center shadow-[0_0_0_6px_rgba(214,187,124,0.15)]">
            <Icon className="w-7 h-7 text-[#D6BB7C]" strokeWidth={2} />
          </span>
          <p className="mt-5 text-xs font-bold uppercase tracking-[0.28em] text-[#D6BB7C]">{pathway.label}</p>
          <h1 className="mt-3 font-serif text-[28px] sm:text-4xl font-semibold leading-tight" data-testid="recap-results-title">{results.title}</h1>
          <p className="mt-3 text-cream/85 text-sm sm:text-base max-w-lg mx-auto leading-relaxed">{results.text}</p>
        </div>
      </div>

      {result.topics && result.topics.length > 0 && (
        <section className="mt-8" data-testid="recap-topics">
          <h2 className="font-serif text-2xl font-semibold text-navy">{results.topicsTitle}</h2>
          <div className="mt-4 flex flex-wrap gap-2.5">
            {result.topics.map((t) => (
              <span key={t} className="inline-flex items-center gap-2 rounded-full border border-gold/50 bg-gold-light px-4 py-2.5 text-sm font-semibold text-navy" data-testid="recap-topic-chip">
                <CheckCircle2 className="w-4 h-4 text-gold" /> {t}
              </span>
            ))}
          </div>
        </section>
      )}

      {recap.length > 0 && (
        <section className="mt-8" data-testid="recap-shared">
          <h2 className="font-serif text-2xl font-semibold text-navy flex items-center gap-2">
            <ClipboardList className="w-6 h-6 text-gold" /> What You Shared
          </h2>
          <div className="mt-4 bg-white rounded-2xl border border-sand divide-y divide-sand/70">
            {recap.map((r) => (
              <div key={r.label} className="px-5 py-3.5 flex flex-col sm:flex-row sm:items-start sm:justify-between gap-1 sm:gap-6">
                <span className="text-xs font-bold uppercase tracking-wider text-slate-500 sm:w-48 shrink-0 pt-0.5">{r.label}</span>
                <span className="text-sm sm:text-base font-semibold text-navy sm:text-right">{r.value}</span>
              </div>
            ))}
          </div>
        </section>
      )}

      {result.review_areas && result.review_areas.length > 0 && (
        <section className="mt-8" data-testid="recap-review-areas">
          <h2 className="font-serif text-2xl font-semibold text-navy">{results.areasTitle}</h2>
          <div className="mt-4 space-y-3">
            {result.review_areas.map((area) => (
              <div key={area.key} className="bg-gold-light/60 rounded-2xl border border-sand p-5" data-testid="review-area-card">
                <p className="font-bold text-navy">{area.title}</p>
                <p className="text-sm text-slate-600 leading-relaxed mt-1">{area.description}</p>
              </div>
            ))}
          </div>
        </section>
      )}

      <div className="mt-8 bg-cream-dark rounded-2xl border border-sand p-5" data-testid="recap-disclaimer">
        <p className="text-xs text-slate-500 leading-relaxed">{results.disclaimer}</p>
      </div>

      <EmailResultsCard assessmentId={assessmentId} pathwayKey={pathway.key} />
      <ReviewCta pathway={pathway} />
    </>
  );
}
